module.exports = __webpack_public_path__ + "static/media/rebirth_2.4e79be71.jpg";